import { EntityModel } from '@/interfaces'
import {
  ALL_AGE_GROUP_SERVICES_QUERY,
  CREATE_AGE_GROUP_SERVICE_MUTATION,
  DELETE_AGE_GROUP_SERVICE_MUTATION,
  FORCE_DELETE_AGE_GROUP_SERVICE_MUTATION,
  SINGLE_AGE_GROUP_SERVICE_QUERY,
  UPDATE_AGE_GROUP_SERVICE_MUTATION,
} from './graphql'
import travelPricingAgeGroupEntity from '@/entities/travelPricingAgeGroup/entity'

const ratioAgeGroupServiceModel: EntityModel = {
  name: 'ageGroupService',
  namePlural: 'ageGroupServices',
  uniqueName: 'ratioAgeGroupService',
  uniqueNamePlural: 'ratioAgeGroupServices',
  path: 'travel/pricing/adaptors/ratio/age_group_service',
  baseUrl: '/travel/pricing/adaptors/ratio/age_group_services',
  translationPrefix: 'entities:ratioAgeGroupService.',
  getDisplayName: (values: any) => {
    return 'Age Group Service'
  },
  gql: {
    getAll: ALL_AGE_GROUP_SERVICES_QUERY,
    getSingle: SINGLE_AGE_GROUP_SERVICE_QUERY,
    create: CREATE_AGE_GROUP_SERVICE_MUTATION,
    update: UPDATE_AGE_GROUP_SERVICE_MUTATION,
    delete: DELETE_AGE_GROUP_SERVICE_MUTATION,
    forceDelete: FORCE_DELETE_AGE_GROUP_SERVICE_MUTATION,
  },
  attributes: {
    ageGroup: {
      name: 'ageGroup',
      label: 'entities:ratioAgeGroupService.attributes.ageGroup.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPricingAgeGroupEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    ratioServiceNo: {
      name: 'ratioServiceNo',
      label: 'entities:ratioAgeGroupService.attributes.ratioServiceNo.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'hidden',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default ratioAgeGroupServiceModel
